import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from '../Link'
import Button from '../Button/'
import * as styles from './index.module.css'

const ProductsHero = ({ title, images, mobileOnlyImages, ctaText, ctaUrl }) => {
  let titleFrags = title.split(';')
  // assume the strategy is random if not fixed

  const isMobile = typeof window !== `undefined` && window.innerWidth <= 1024
  const titleColor = titleFrags.length > 1 ? titleFrags[1] : '#000000'
  let image = images[0]
  if (isMobile && mobileOnlyImages) {
    image = mobileOnlyImages[0]
  }

  return (
    <div className={styles.container}>
      <div className={`${styles.mobileOnly}`}>
        <div className={`${styles.details}`}>
          <h2 className={styles.title} style={{ color: titleColor }}>
            {titleFrags[0]}
          </h2>
          {ctaUrl && ctaText && (
            <div className={styles.talkToSales}>
              <Link to={ctaUrl}>
                <Button className={styles.tts}>{ctaText}</Button>
              </Link>
            </div>
          )}
        </div>
      </div>
      <div>
        <GatsbyImage
          image={image.iphero}
          className={styles.heroImage}
          alt={image?.description}
        />
      </div>

      <div className={`${styles.nonmobile} ${styles.details}`}>
        <h1 className={styles.title} style={{ color: titleColor }}>
          {titleFrags[0]}
        </h1>
        {ctaUrl && ctaText && (
          <div className={styles.talkToSales}>
            <Link to={ctaUrl}>
              <Button className={styles.tts}>{ctaText}</Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}
export default ProductsHero
